import * as R from 'ramda'

export default class Item {
  constructor (stateObj, menu, cartElementBuilder) {
    this.stateObj = stateObj
    this._itemDefinition = menu.items[stateObj.id]
    this._menu = menu
    this.cartElementBuilder = cartElementBuilder
  }

  get id () { return this._itemDefinition.id }
  get title () { return this._itemDefinition.title }
  get abbreviation () { return this._itemDefinition.abbreviation }
  get price () { return parseFloat(this._itemDefinition.price) }
  get description () { return this._itemDefinition.description }
  get allowSpecialRequests () { return this._itemDefinition.specialRequests }
  get coverImgUrl () { return this._itemDefinition.coverImgUrl }
  get detailImgUrl () { return this._itemDefinition.detailImgUrl }
  get instanceId () { return this.stateObj.instanceId }
  get questionIds () {
    return this._itemDefinition.questions || []
  }
  get kitchenStationId () {
    return this._itemDefinition.kitchenStationId || {}
  }

  // TODO: finish this
  get allLevelSelectedQuestionIds () {
    return []
  }

  get questions () {
    return this.questionIds
      ? this.questionIds.map(qid => this.cartElementBuilder.buildQuestion(qid, this.stateObj, this._menu))
      : []
  }

  get allLevelQuestions () {
    return this.questionIds.length !== 0
      ? this.questionIds
        .map(qid => this.cartElementBuilder.buildQuestion(qid, this.stateObj, this._menu))
        .map(q => [q].concat(q.activeSubQuestions))
        .reduce((a, qs) => a.concat(qs), [])
      : []
  }

  get isValid () {
    return this.questions ? this.questions.every(q => q.isValid) : true
  }

  get inValidQuestions () {
    return this.questions ? this.questions.reduce((r, q) => r.concat(q.inValidQuestions), []) : []
  }

  get totalPrice () { return parseFloat(this.price + (this.questions.map(q => q.totalPrice).reduce((t, n) => t + n, 0))) }

  get values () {
    return this.stateObj.values
  }

  equalsToItem (item) {
    const hasSameValueAmount = Object.keys(this.stateObj.values).length === Object.keys(item.stateObj.values).length
    return this.id === item.id && hasSameValueAmount && Object.keys(this.stateObj.values).every(k =>
      R.equals(this.stateObj.values[k], item.stateObj.values[k]))
  }
}
